import { PhIcon } from './PhIcon';

/**
 * author: Michael Irigoyen
 * id 57738B55-57CB-47EF-9758-32686AA78212
 * name ph
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ph.svg
 * tags
 * - Science 
 * - Home Automation 
 */
export const BaseIcon = PhIcon;
export default BaseIcon